export default {
	__typename: 'Query',
	networkStatus: {
		isConnected: true,
		__typename: 'NetworkStatus',
	},
	template: {
		items: [],
		__typename: 'Template',
	},
};
